import { call, put, takeLatest, select } from 'redux-saga/effects';

import { getVersions } from '../../../api/version.saga';
import { TDC_ABOUT_FETCH_SERVICES, setAboutModalServices } from './AboutModal.actions';
import { getAboutModalServices } from './AboutModal.selectors';
import { Versions } from './AboutModal.types';

export function* getBackendServices() {
	const services: Versions = yield select(getAboutModalServices);
	if (Object.keys(services).length === 0) {
		const { data, response } = yield call(getVersions);
		if (response.ok) {
			yield put(setAboutModalServices(data));
		}
	}
}

export function* aboutModalSaga() {
	yield takeLatest(TDC_ABOUT_FETCH_SERVICES, getBackendServices);
}
